import { MarketplaceType } from '~client/model/marketplace-type';

// TODO(Dmitry): Move these helpers to common and refactor other functions to use them

/**
 * Returns TRUE if passed marketplace type is draw (Wish List)
 * @param type
 */
export const isMarketplaceDraw = (type: MarketplaceType): boolean => type === MarketplaceType.DRAW;

/**
 * Returns TRUE if passed marketplace type is auction (My Price)
 * @param type
 */
export const isMarketplaceAuction = (type: MarketplaceType): boolean =>
  type === MarketplaceType.AUCTION;

/**
 * Returns TRUE if passed marketplace type is secondary exchange (Resale)
 * @param type
 */
export const isMarketplaceResale = (type: MarketplaceType): boolean =>
  type === MarketplaceType.SECONDARY_EXCHANGE;

/**
 * Returns TRUE if passed marketplace type is client guest (Guest List)
 * @param type
 */
export const isMarketplaceClientGuest = (type: MarketplaceType): boolean =>
  type === MarketplaceType.CLIENT_GUEST;

/**
 * Returns TRUE if passed marketplace type is purchase dynamic price [Market (with Support)]
 * @param type
 */
export const isMarketplacePurchaseDynamic = (type: MarketplaceType): boolean =>
  type === MarketplaceType.PURCHASE_DYNAMIC_PRICE;

/**
 * Returns TRUE if passed marketplace type is promoter
 * @param type
 */
export const isMarketplacePromoter = (type: MarketplaceType): boolean =>
  type === MarketplaceType.PROMOTER;



// WEBPACK FOOTER //
// ./view/components/details/helper/marketplace.helper.ts